<template>
  <div>
    <div class="title-level">
      <h1 class="title">Shipments</h1>

      <div class="date-range filter">
        <vs-input type="date" label="Start Date" v-model="startDate" />
        <vs-input type="date" label="End Date" v-model="endDate" />
      </div>
    </div>

    <vs-table striped>
      <template #thead>
        <vs-tr>
          <vs-th sort @click="shipments = $vs.sortData($event, shipments, 'name')">Model Number</vs-th>
          <vs-th sort @click="shipments = $vs.sortData($event, shipments, 'qty')">QTY</vs-th>
          <vs-th sort @click="shipments = $vs.sortData($event, shipments, 'scheduled_ship_date')">Scheduled Ship Date</vs-th>
          <vs-th sort @click="shipments = $vs.sortData($event, shipments, 'status')">Status</vs-th>
          <vs-th sort @click="shipments = $vs.sortData($event, shipments, 'shipped')">Shipped</vs-th>
          <vs-th>Action</vs-th>
        </vs-tr>
      </template>

      <template #tbody>
        <vs-tr v-for="shipment in filteredShipments" :key="shipment.id" :data="shipment">
          <vs-td>{{ shipment.name }}</vs-td>
          <vs-td>{{ shipment.qty }}</vs-td>
          <vs-td>{{ formatDate(shipment.scheduled_ship_date) }}</vs-td>
          <vs-td>
            <div v-if="shipment.status === 'green'" class="circle green"></div>
            <div v-else-if="shipment.status === 'red'" class="circle red"></div>
          </vs-td>
          <vs-td>
            <div v-if="shipment.shipped === shipment.qty" class="circle green"></div>
            <div v-else-if="shipment.shipped === 0" class="circle red"></div>
            <div v-else class="circle yellow"></div>
          </vs-td>
          <vs-td>
            <router-link :to="{ path: '/details', query: { title: shipment.title, orders: shipment.orders }}">View Shipment</router-link>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Shipments',

  data() {
    return {
      shipments: [],
      startDate: null,
      endDate: null,
    };
  },

  computed: {
    filteredShipments() {
      return this.shipments.filter((shipment) => {
        if (this.startDate && this.endDate) {
          return shipment.scheduled_ship_date.isSameOrAfter(this.startDate, 'day')
            && shipment.scheduled_ship_date.isSameOrBefore(this.endDate, 'day');
        }

        return true;
      });
    },
  },

  created() {
    const orders = this.$store.state.orders;
    const shipments = [];
    const mergedShipments = [];

    orders.forEach((order) => {
      order.contents.forEach((item) => {
        shipments.push({
          name: item.name,
          qty: item.qty,
          shipped: item.shipped,
          scheduled_ship_date: item.scheduled_ship_date ? moment(item.scheduled_ship_date) : null,
          title: `${item.name} Shipment (${item.scheduled_ship_date ? moment(item.scheduled_ship_date).format('l') : 'No Date'})`,
          orders: [order.id],
          status: item.status,
        });
      });
    });

    shipments.forEach((shipment) => {
      const index = mergedShipments.findIndex((mergedShipment) => {
        return mergedShipment.name === shipment.name
          && mergedShipment.scheduled_ship_date.isSame(shipment.scheduled_ship_date, 'day');
      });

      if (index >= 0) {
        mergedShipments[index].qty += shipment.qty;
        mergedShipments[index].shipped += shipment.shipped;

        if (mergedShipments[index].status === 'green') {
          mergedShipments[index].status = shipment.status;
        }

        shipment.orders.forEach((order) => {
          if (!mergedShipments[index].orders.includes(order)) {
            mergedShipments[index].orders.push(order);
          }
        });
      } else {
        mergedShipments.push(shipment);
      }
    });

    this.shipments = mergedShipments;
  },

  methods: {
    formatDate(date) {
      return date.format('ll');
    },
  },
};
</script>
